import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IProducts } from '../models/products.model';

export const upcomingProductsForSomeoneElseFeatureKey = 'upcomingProductsForSomeoneElse';

export interface UpcomingProductsForSomeoneElseState {
  loadUpcomingProductsForSomeoneElseResponse: IProducts[];
  loadUpcomingProductsForSomeoneElseFailure: Error | any;
}

export const initialState: UpcomingProductsForSomeoneElseState = {
  loadUpcomingProductsForSomeoneElseResponse: undefined,
  loadUpcomingProductsForSomeoneElseFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadUpcomingProductsForSomeoneElse, (state, action) => ({
    ...state
  })),
  on(actions.loadUpcomingProductsForSomeoneElseSuccess, (state, action) => ({
    ...state,
    loadUpcomingProductsForSomeoneElseResponse: action.response
  })),
  on(actions.loadUpcomingProductsForSomeoneElseFailure, (state, action) => ({
    ...state,
    loadUpcomingProductsForSomeoneElseFailure: action.error
  }))
);

export const getUpcomingProductsForSomeoneElseResponse = (state: UpcomingProductsForSomeoneElseState) =>
  state.loadUpcomingProductsForSomeoneElseResponse;
